import * as Yup from 'yup';
import { StepMainProductionSiteForm } from '../step-main-production-site/step-main-production-site-types';

export const stepMergingProductionSiteSchema = () =>
  Yup.object<StepMainProductionSiteForm>().shape({
    mergingProductionSite: Yup.mixed().nullable().required('Povinné pole'),
  });
